/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
import { useState, useEffect } from 'react'
import { IconButton, MenuOption } from '@maas-components/core'
import { Typography, Grid } from '@material-ui/core'
import AddOutlinedIcon from '@material-ui/icons/AddOutlined'
import RemoveCircleOutlineOutlinedIcon from '@material-ui/icons/RemoveCircleOutlineOutlined'
import { Form, Formik } from 'formik'
import * as Analytics from 'core/common/analytics'
import i18n from 'core/common/i18n'
import { getErrorMessage, validateField } from 'core/common/utils/validation'
import { Card, CardContent, Button } from 'core/components/Core'
import TextField from 'core/components/TextField'
import ProductRelevanceCallout from 'core/containers/ProductRelevanceCallout'
import { useAppContext } from 'core/pages/ProductNew-v2/context/AppContext'
import { useFormContext } from 'core/pages/ProductNew-v2/context/ProductNewContext'
import ProductDialogSelectAttributes from './components/ProductDialogSelectAttributes'
import { ProductDatasheetFormSchema } from './schema'
import * as S from './style'

const defaultFormData = {
  datasheet: [],
}

export const ProductDatasheetForm = ({ onNext, isEditMode, onEditSubmit, custom, formMode }) => {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { formData, setFormData } = useFormContext()
  const [initialDatas, setInitialDatas] = useState([])
  const [initialDataValues, setInitialDataValues] = useState(defaultFormData)
  const [hiddenFields, setHiddenFields] = useState([])
  const [open, setOpen] = useState(false)
  const { modalDataSheetLoading } = useAppContext()

  useEffect(() => {
    const submitEdit = async () => {
      if (isSubmitting && isEditMode && onEditSubmit) {
        setIsSubmitting(false)
        setIsLoading(true)
        try {
          await onEditSubmit(formData)
          setIsLoading(false)
        } catch (error) {
          console.error('Error during API call', error)
        } finally {
          setIsLoading(false)
        }
      }
    }

    submitEdit()
  }, [isSubmitting, formData, isEditMode, onEditSubmit])

  const onSubmit = values => {
    Analytics.ProductDatasheetSaved(formMode)

    setFormData(prevData => ({
      ...prevData,
      datasheet: values.datasheet.map(attr => ({
        type: attr.type.trim(),
        value: attr.value.trim(),
        typeSelection: attr.typeSelection,
        values: attr.values,
      })),
    }))

    setIsSubmitting(true)
    onNext()
  }

  const handleValidation = async ({ validateForm }) => {
    const errors = await validateForm()

    if (Object.keys(errors).length) {
      Analytics.ProductDatasheetValidationError(formMode)
    }
  }

  const handleAddSelectedAttributes = ({ selectedAttributes, setFieldValue, values }) => {
    const newFields = selectedAttributes.filter(
      attr => !values.datasheet.find(datasheetField => datasheetField.type === attr.type)
    )

    setFieldValue('datasheet', [...values.datasheet, ...newFields])
  }

  const handleDeleteAttribute = ({ attribute, setFieldValue, values }) => {
    setFieldValue(
      'datasheet',
      values.datasheet.filter(currentAttr => currentAttr.type !== attribute.type)
    )
  }

  useEffect(() => {
    const initialValues = {
      datasheet: formData.datasheet.length
        ? formData.datasheet
        : initialDatas.map(field => ({ type: field.name, value: '' })),
    }

    setInitialDataValues(initialValues) // Atualiza o estado inicial
  }, [initialDatas, formData.datasheet])

  // useEffect(() => {
  //   const initialDataValues = initialDatas.map(item => {
  //     return {
  //       type: item.name,
  //       value: '',
  //     }
  //   })
  //   setInitialDataValues({ datasheet: initialDataValues })
  // }, [initialDatas])

  const renderAttributes = ({
    handleChange,
    setFieldValue,
    values,
    errors,
    touched,
    submitCount,
  }) => {
    if (!values.datasheet) return null

    return (
      <Grid container className="mb-3" spacing={4}>
        {custom?.component
          ? custom.component({
              validateField,
              getErrorMessage,
              handleChange,
              errors,
              touched,
              submitCount,
              values,
              setFormData,
              setHiddenFields,
              setInitialDatas,
              initialDataValues,
            })
          : null}

        {values.datasheet
          .filter(attr => attr.type !== 'Departamento BS')
          .map((attr, idx) => {
            const isDeparmentBS = attr.type === 'Departamento BS'
            const isHidden = hiddenFields.includes(attr.type)

            return (
              <>
                <Grid
                  item
                  key={attr.type}
                  className="d-flex mb-2"
                  xs={6}
                  style={{ display: isHidden ? 'none' : 'flex' }}
                >
                  {(attr.typeSelection && attr.typeSelection === 'TIPO_SELECAO_COMBO') ||
                  attr.typeSelection === 'TIPO_SELECAO_LISTA' ? (
                    <>
                      <TextField
                        fullWidth
                        onChange={handleChange}
                        select
                        placeholder={attr.type}
                        id={`field-${attr.code}`}
                        inputProps={{ maxLength: 50, minLength: 1 }}
                        name={`datasheet.${idx}.value`}
                        value={values.datasheet?.[idx]?.value || ''}
                        required
                        label={attr.type}
                        error={validateField(
                          `datasheet.${idx}.value`,
                          errors,
                          touched,
                          submitCount > 0
                        )}
                        helperText={getErrorMessage(`datasheet.${idx}.value`, errors, touched)}
                      >
                        {attr.values.map(option => (
                          <MenuOption key={option.code} value={option.normalized_value}>
                            {option.value}
                          </MenuOption>
                        ))}
                      </TextField>
                    </>
                  ) : (
                    <>
                      <TextField
                        fullWidth
                        hiddenLabel
                        name={`datasheet.${idx}.value`}
                        placeholder={attr.type}
                        onChange={handleChange}
                        value={attr.value}
                        sanitize
                        inputProps={{ maxLength: 50, minLength: 1 }}
                        error={validateField(
                          `datasheet.${idx}.value`,
                          errors,
                          touched,
                          submitCount > 0
                        )}
                        helperText={getErrorMessage(`datasheet.${idx}.value`, errors, touched)}
                      />
                    </>
                  )}

                  <TextField
                    type="hidden"
                    fullWidth
                    hiddenLabel
                    name={`datasheet.${idx}.type`}
                    placeholder={attr.type}
                    onChange={handleChange}
                    value={attr.type}
                    style={{ display: 'none' }}
                    sanitize
                    inputProps={{ maxLength: 50, minLength: 1 }}
                    error={validateField(`datasheet.${idx}.type`, errors, touched, submitCount > 0)}
                    helperText={getErrorMessage(`datasheet.${idx}.type`, errors, touched)}
                  />

                  {!isDeparmentBS && (
                    <IconButton
                      color="primary"
                      style={{ alignItems: 'unset' }}
                      onClick={() =>
                        handleDeleteAttribute({ attribute: attr, values, setFieldValue })
                      }
                      aria-label={i18n.t('productNew.datasheet.deleteButtonAriaLabel')}
                    >
                      <RemoveCircleOutlineOutlinedIcon />
                    </IconButton>
                  )}
                </Grid>
              </>
            )
          })}
      </Grid>
    )
  }

  return (
    <Formik
      key={initialDataValues}
      initialValues={initialDataValues}
      onSubmit={onSubmit}
      validationSchema={ProductDatasheetFormSchema}
      enableReinitialize
    >
      {formikProps => (
        <Form className="w-100">
          <Card raised elevation={1} className="p-4">
            <CardContent className="p-0">
              {!isEditMode && (
                <Typography variant="h5" component="h2" className="mb-4">
                  {custom?.title || i18n.t('productNew.datasheet.title')}
                </Typography>
              )}
              <Typography variant="body1" color="secondary" className="mb-4">
                {i18n.t('productNew.datasheet.subtitle')}
              </Typography>

              <ProductRelevanceCallout
                recommendations={[i18n.t('productNew.datasheet.relevanceRecommendation')]}
                disableScoreInfo={custom?.disableScoreInfo}
                onClick={() => Analytics.ProductDatasheetRelevanceClicked(formMode)}
              />

              {renderAttributes(formikProps)}

              <S.Button
                color="primary"
                disabled={custom?.component && modalDataSheetLoading}
                onClick={() => setOpen(true)}
                startIcon={<AddOutlinedIcon color="primary" />}
                variant="outlined"
                className="mb-3"
              >
                {i18n.t('productNew.datasheet.addAttribute')}
              </S.Button>
              <div className="w-100 d-flex justify-end">
                {!isEditMode && (
                  <Button
                    disabled={custom?.component && modalDataSheetLoading}
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      formikProps.handleSubmit()
                      handleValidation({ validateForm: formikProps.validateForm })
                    }}
                  >
                    {i18n.t('productNew.actions.continue')}
                  </Button>
                )}

                {isEditMode && (formikProps.dirty || isLoading) && (
                  <>
                    <Button
                      variant="text"
                      color="primary"
                      onClick={() => formikProps.resetForm()}
                      className="mr-2"
                    >
                      <span>Cancelar</span>
                    </Button>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        formikProps.handleSubmit()
                        handleValidation({ validateForm: formikProps.validateForm })
                      }}
                      loading={isLoading}
                    >
                      <span>Salvar</span>
                    </Button>
                  </>
                )}
              </div>
              {open && (
                <ProductDialogSelectAttributes
                  open={open}
                  onClose={() => setOpen(false)}
                  handleAddSelectedAttributes={selectedAttributes =>
                    handleAddSelectedAttributes({ selectedAttributes, ...formikProps })
                  }
                  disableCreateAttribute={custom?.disableCreateAttribute}
                />
              )}
            </CardContent>
          </Card>
        </Form>
      )}
    </Formik>
  )
}
